export const getImagesData = collection =>
  collection.collectionDetails && collection.collectionDetails.imageKeys;
